// @flow

import React from 'react';
import styled from 'styled-components';
import typeof theme from '../theme';

type Variants = {
  center?: boolean,
  size?: 'tiny' | 'small' | 'standard',
};
type TP = {
  ...Variants,
  theme: theme,
};

type Props = {
  ...Variants,
  className: string,
};

const LoaderImpl = ({ className, center, size, ...props }: Props) => (
  <div className={`loader-container ${className}`}>
    <div {...props} className={`loader`} />
  </div>
);

const sizes = {
  tiny: '0.25em',
  small: '0.5em',
  standard: '1em',
};

const center = ({ center, theme }: TP) => {
  if (center === true) {
    return `margin: ${theme.spacing.wide} auto; display: block`;
  }
};

const size = ({ size }: TP) => {
  if (typeof size === 'undefined') {
    return;
  }
  if (process.env.NODE_ENV !== 'production') {
    if (sizes.hasOwnProperty(size) === false) {
      console.warn('<Loader received unexpected size property: "%s"', size);
    }
  }
  return `font-size: ${sizes[size] || sizes.standard};`;
};

const Loader = styled(LoaderImpl)`
  ${center};
  ${size};
`;

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js